import { submitCardCvv } from "../../services/api";
import { formatPaymentResponse } from "./utils";

export const sdkSubmitCardCvv = async ({
  intentId,
  cvv,
  installmentPlanData,
  loyaltyData,
  lang,
}: {
  intentId: string;
  cvv: string;
  lang: string;
  installmentPlanData?: {
    planId: string;
    issuerCode?: string;
  };
  loyaltyData?: LoyaltyPayload;
}) => {
  try {
    const paymentResponse = (await submitCardCvv({
      cvv,
      lang,
      installmentPlanData,
      loyaltyData,
      intentId,
    })) as unknown as PaymentApiResponse;

    return formatPaymentResponse(paymentResponse);
  } catch (error) {
    const errorsList = (await error?.json)?.status?.errors || [];
    return Promise.reject({
      isHttpError: error.isHttpError,
      json: errorsList.reduce((acc, curr) => ({ ...acc, ...curr }), {}),
    });
  }
};
